import { render, staticRenderFns } from "./Accounting.vue?vue&type=template&id=3a45cd19&scoped=true&"
import script from "./Accounting.vue?vue&type=script&lang=js&"
export * from "./Accounting.vue?vue&type=script&lang=js&"
import style0 from "./Accounting.vue?vue&type=style&index=0&id=3a45cd19&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a45cd19",
  null
  
)

export default component.exports